import styled from "styled-components";
import { AiOutlineCheck } from "react-icons/ai";

export const IconCheck = styled(AiOutlineCheck)`
  width: auto;
  height: 30px;
  color: #378bbf;
  &:hover {
    animation: flicker-1 2s linear infinite both;
    @keyframes flicker-1 {
      0%,
      100% {
        opacity: 1;
      }
      41.99% {
        opacity: 1;
      }
      42% {
        opacity: 0;
      }
      43% {
        opacity: 0;
      }
      43.01% {
        opacity: 1;
      }
      47.99% {
        opacity: 1;
      }
      48% {
        opacity: 0;
      }
      49% {
        opacity: 0;
      }
      49.01% {
        opacity: 1;
      }
    }
  }
`;
